import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import {
  GetReferralRequestDocument,
  GetReferralRequestQuery,
  ReferralRequestStatus,
} from '../generated/referral-request';

const useReferralRequest = (id: string, status: ReferralRequestStatus) => {
  const [{ data, fetching, errorMessage }] = useSecureGraphqlQuery<GetReferralRequestQuery>({
    query: GetReferralRequestDocument,
    variables: { id, status },
    pause: !id,
  });

  return { referralRequest: data?.getReferralRequest ?? undefined, fetching, errorMessage };
};

export { useReferralRequest };
